import { DonutChart, HexColor } from '@silverfort/sf-components';
import Card from './card';
import { useServiceAccountContext } from '../../contexts/ServiceAccountContext';
import { RISK_LEVELS } from '@silverfort-nodelibs/common/utils/consts';
import { capitalizeFirstLetter } from '@silverfort-nodelibs/common/utils/common';
import { bigNumberToText } from '../../../../../components/utils';

const RISK_COLORS: Record<number, HexColor> = {
    [RISK_LEVELS.CRITICAL.value]: '#C5192F',
    [RISK_LEVELS.HIGH.value]: '#F5445A',
    [RISK_LEVELS.MEDIUM.value]: '#FC8154',
    [RISK_LEVELS.LOW.value]: '#F7B748'
};

const ServiceAccountsRiskLevels = () => {
    const { riskLevelsCounter, isFetchingInsights, setActiveFilters } = useServiceAccountContext();

    const totalServiceAccounts = bigNumberToText(Object.values(riskLevelsCounter).reduce((acc, curr) => acc + curr, 0));
    return (
        <Card title="Service Accounts by Risk Level">
            <div className="h-full w-full p-4 pr-8 flex items-center justify-center text-sf">
                <DonutChart
                    data={Object.values(RISK_LEVELS)
                        .map(({ label, value }) => ({
                            name: capitalizeFirstLetter(label),
                            value: riskLevelsCounter[value],
                            fill: RISK_COLORS[value],
                            formattedValue: bigNumberToText(riskLevelsCounter[value]),
                            onClick: () => setActiveFilters((activeFilters) => ({ ...activeFilters, risk: [value] }))
                        }))
                        .reverse()}
                    isMappingVisible
                    totalText={totalServiceAccounts}
                    isLoading={isFetchingInsights}
                    innerRadius={50}
                    outerRadius={60}
                    chartSize={120}
                />
            </div>
        </Card>
    );
};

export default ServiceAccountsRiskLevels;
